import styled from "styled-components";

import { windowWidth } from "@styles/global";

interface KanbanCardSummaryIconProps {
  primarycolor: string;
}

const KanbanCardSummaryContainer = styled.div<KanbanCardSummaryIconProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  overflow: hidden;
  width: 100%;

  > #kanbanSectionIcon {
    fill: ${(props) => props.primarycolor};

    min-width: 37px;
    width: 37px;
    height: 37px;
  }
`;

const KanbanCardSummaryinfos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 14px;
  color: #666666;
  overflow: hidden;

  #title1,
  #title2 {
    font-size: 15px;
    font-weight: 600;
    color: black;
  }

  @media (max-width: ${windowWidth.laptop.large}) {
    font-size: 13px;
  }
`;

export { KanbanCardSummaryContainer, KanbanCardSummaryinfos };
